import React from 'react';

const STATUS_COLOR = {
  online: '#22c55e',
  away: '#f59e0b',
  busy: '#ef4444',
  idle: '#94a3b8',
  offline: '#cbd5e1',
};

const StatusDot = ({ status = 'offline', size = 10, title, style }) => {
  const color = STATUS_COLOR[status] || STATUS_COLOR.offline;
  return (
    <span
      title={title || status}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        border: '1px solid light-dark(#ffffff, #2a2e36)',
        boxShadow: '0 0 0 1px rgba(0,0,0,0.08)',
        ...style,
      }}
    />
  );
};

export default StatusDot;
